import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import {
  AboutBlock,
  ContactOpts,
  FooterLegal,
  GetInContact,
  Hr,
  IFAQ,
  NarrowPage,
  NewsletterBox,
  StackLogos,
} from '@sthzg/sthzgnet-branding';
import '../styles/global';

const IndexPage = ({ data }) => (
  <NarrowPage>
    <Helmet>
      <title>{data.site.siteMetadata.title}</title>
      <meta name="description" content={data.site.siteMetadata.description} />
    </Helmet>
    <StackLogos />
    <Hr />
    <AboutBlock />
    <Hr />
    <ContactOpts />
    <Hr />
    <NewsletterBox />
    <Hr />
    <IFAQ />
    <Hr />
    <GetInContact />
    <Hr />
    <FooterLegal />
  </NarrowPage>
);

IndexPage.propTypes = {
  data: PropTypes.shape({
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export const query = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
        description
      }
    }
  }
`;

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.jsx